import gql from 'graphql-tag'

export const deleteJobType = gql`
  mutation ($job_type_id: Float!, $workspace_id: Float!) {
    deleteJobType(job_type_id: $job_type_id, workspace_id: $workspace_id) {
      status
      msg
      data
    }
  }
`
